import React, { createContext, useContext, useMemo, useState } from 'react';

export const FooterContext = createContext(null);

export function useFooter() {
  return useContext(FooterContext);
}

export default function FooterProvider({ children }) {
  const [content, setContent] = useState(null);

  const context = useMemo(
    () => ({
      content,
      setFooterContent: setContent,
    }),
    [content],
  );

  return <FooterContext.Provider value={context}>{children}</FooterContext.Provider>;
}
